//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowTitle from '../../components/common/ContainerRowTitle'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowInstructionLink from '../../components/common/ContainerRowInstructionLink'
import InvoiceHeaderContainer from './InvoiceHeaderContainer'
import LineItemsContainer from './LineItemsContainer'

const InvoiceDataExtractionForm = props => {
    const { location,deimos } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Invoice Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'} />
            <ContainerRowInstructionLink docLink={query.docUrl} instructionLink={'https://docs.google.com/document/d/e/2PACX-1vRqHiTUHXlX7EGAqzsjisiDz014r_x0V8l6fLbxBpjYHLxgfm4dpBRry6cAbSarA7sRmjZFPG5PQOCG/pub?embedded=true'} />
            <InvoiceHeaderContainer query={query}/>
            <LineItemsContainer
                isTriggerAddLineItem={deimos.addEditLineItem}
                jwt={query.jwt}
                taskAcceptedInfoId={query.taskAcceptedInfoId}
            />
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        deimos: state.deimos
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectDeimos/InvoiceDataExtractionForm.js